import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.chime_deposit,
    (chime_deposit) => {
        return {
            props: chime_deposit[chime_deposit.stage]
        }
    }
)